/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2014, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define({
	'dlg_loading': 'Chargement...',
	'dlg_close': 'Fermer',
	'dlg_ok': 'OK',
	'dlg_cancel': 'Annuler',
	'dlg_back': 'Revenir en arrière',
	'dlg_done': 'Terminé',

	// Slider
	'sliderRegionLabel': 'Curseur, utilisez les flèches vers la droite et vers la gauche pour déplacer les poignées du curseur',
	'sliderHandleLabel': 'Poignée du curseur',
	'a11ySliderHandleLabel': 'Poignée du curseur %{sliderValue}',
	'sliderInputLabel': 'valeur',

	// Side bar
	'sidebarAdd': 'Ajouter',
	'clearTextFilterValue': 'Effacer',
	'missingDataSetData': 'Les données de cet ensemble de données ne sont pas disponibles. Actualisez l\'ensemble de données ou prenez contact avec votre administrateur pour accéder à la source.',

	// Toolbar
	'toolbarRegionLabel': 'Barre d\'outils',
	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',
	//TextToolbar
	'fontSelect': 'Famille de polices',
	'fontSizeSelect': 'Taille de la police',
	'fontColorSelect': 'Couleur',
	'fontStyle': 'Style',
	'colorPickerTitle': 'Sélection d\'une couleur',
	'bold': 'Gras',
	'italic': 'Italique',
	'underline': 'Soulignement',
	'fontAlignment': 'Alignement',
	'justifyLeft': 'Aligner à gauche',
	'justifyCenter': 'Aligner au centre',
	'justifyRight': 'Aligner à droite',
	'insertOrderedList': 'Liste numérotée',
	'insertUnorderedList': 'Liste non numérotée',
	'fontColorPicker': 'Sélecteur de couleur',
	'textWrap': 'Renvoyer à la ligne automatiquement',
	'restore': 'Restaurer les valeurs par défaut',
	// Top Bottom
	'topbottomNumberOfResultsLabel': 'Nombre de résultats (%{lower} - %{higher})',
	'topbottomPercentLabel': 'Pourcentage (%{lower}% - %{higher}%)',
	'topbottomSelectOption': 'Option Premier ou dernier',
	'topbottomOptionLabel': 'Afficher',
	'searchByLabel': 'Par',
	'searchNoMatches': 'Aucun résultat trouvé',
	'topbottomRankColumnLabel': 'Ajouter une colonne de classement à la table',
	'topbottomNone': 'Aucun',
	'topCount': 'Nombre le plus élevé',
	'topPercent': 'Premiers %',
	'bottomCount': 'Nombre le plus bas',
	'bottomPercent': 'Derniers %',
	'searchColumn': 'Rechercher une colonne',
	'searchColumnAriaLabel': 'Recherchez une colonne. Entrez le nom de la colonne à rechercher, puis utilisez la flèche vers le bas pour rechercher la colonne dans une liste.',
	'searchColumnQualifiedLabel': '%{columnLabel} (%{columnId})',
	'rankColumnLabel': 'Rang (%{columnLabel})',
	'topbottomClearLabel': 'Réinitialiser',

	// Format
	'formatAuto': 'Automatique',
	'formatConvertPercent': 'Convertir le décimal en pourcentage',
	'formatAbbreviate': 'Abréger',
	'formatUseGrouping': 'Utiliser le séparateur des milliers',
	'dateStyle': 'Style de date',
	'dateTimeStyle': 'Style de date/heure',
	'formatMissingValueCharactersInfo': 'Les caractères de valeurs manquantes indiquent les caractères à afficher lorsque la valeur est manquante.',
	'currencySymbolLabel': 'Symbole de la devise',
	'customSymbolPlaceholder': 'Ajouter un symbole',
	'customSymbolLabelInfo': 'Indique un ou plusieurs caractères à utiliser comme symbole personnalisé. Le symbole est inséré avant le nombre et avant tout signe qui le précède.',
	'numberLabel': 'Libellé de nombre',
	'numberPositionLabel': 'Position du libellé',
	'numberLabelInfo': 'Indique un libellé pour le nombre formaté et placé en tant que préfixe ou suffixe en fonction de la position du libellé.',
	'nullValueDefault': '<par défaut>',
	'nullValueContent': '(pas de valeur)',
	'default': 'Par défaut',
	'beginning': 'Début',
	'end': 'Fin',
	'formatLabel': 'Sélectionner un format',

	// More data indicator
	'moreDataIndicator': 'Vos données ont été tronquées à %{threshold} éléments. Appliquez un filtre pour en afficher moins.',

	// Expanded View / Focus mode
	'evCollapse': 'Réduire',
	'duplicate': 'Dupliquer',
	'copyOf': 'Copie de %{name}',
	'unableToDuplicateBoard': 'Impossible de dupliquer "%{name}".',

	// Widget list
	'errorLoadingWidgetList': 'Impossible de charger les objets',

	// Custom widgets
	'customWidget': 'Widget personnalisé'
});
